import { VehicleType } from "@busbud/int-schemas/lib/vehicles";
import { LayoutType } from "@busbud/int-schemas/udm";

export const VehicleCategoryKey = {
  All: "all",
  ...VehicleType
} as const;
export const DEFAULT_VEHICLE_CATEGORY_KEY = VehicleCategoryKey.All;
export const VehicleCategories = Object.values(VehicleCategoryKey);

export const VehicleLayoutTypeKey = {
  All: "all",
  ...LayoutType
} as const;
export const DEFAULT_VEHICLE_LAYOUT_TYPE_KEY = VehicleLayoutTypeKey.All;

export const BLABLACAR_SOURCE_ID = 506;
export const POPARIDE_SOURCE_ID = 827;

export const CURATION_BINNABLE_SOURCES: Array<number> = [
  BLABLACAR_SOURCE_ID,
  POPARIDE_SOURCE_ID
];
